// extracted by mini-css-extract-plugin
export default {"CopyUrlWrapper":"CopyUrl_CopyUrlWrapper__p0ZdC","Link":"CopyUrl_Link__oSsqi","Button":"CopyUrl_Button__wF0g-","Active":"CopyUrl_Active__heaaY"};